module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-api-places"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Google Places API.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n          Request for Google Places search & Google Street View images.\n        ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ab8574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_showcase/ApiPlaces.vue
// module id = 822
// module chunks = 1